/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PayerContract } from './PayerContract';
import {
    PayerContractFromJSON,
    PayerContractFromJSONTyped,
    PayerContractToJSON,
} from './PayerContract';

/**
 * 
 * @export
 * @interface GetPayerContracts200Response
 */
export interface GetPayerContracts200Response {
    /**
     * 
     * @type {Array<PayerContract>}
     * @memberof GetPayerContracts200Response
     */
    data?: Array<PayerContract>;
}

/**
 * Check if a given object implements the GetPayerContracts200Response interface.
 */
export function instanceOfGetPayerContracts200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function GetPayerContracts200ResponseFromJSON(json: any): GetPayerContracts200Response {
    return GetPayerContracts200ResponseFromJSONTyped(json, false);
}

export function GetPayerContracts200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetPayerContracts200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(PayerContractFromJSON)),
    };
}

export function GetPayerContracts200ResponseToJSON(value?: GetPayerContracts200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(PayerContractToJSON)),
    };
}

